module.exports = __webpack_public_path__ + "static/sedex-010b3ab2708e7a3d0515521018d72e32.png";